var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Delete",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M25.78,18.73A2.6,2.6,0,0,1,28.5,16h6.94a2.6,2.6,0,0,1,2.73,2.75v1.08H45a1.44,1.44,0,0,1,1,.3,1.05,1.05,0,0,1,.38,1.13,1.19,1.19,0,0,1-1,.91,2.81,2.81,0,0,1-.65,0c-.43,0-.85,0-1.33,0V43.47a4.37,4.37,0,0,1-3.47,4.42,5,5,0,0,1-1.09.09Q32,48,25.13,48a4.4,4.4,0,0,1-4.54-4.56V22.24c-.63,0-1.2,0-1.78,0a1.2,1.2,0,0,1-.29-2.36,1.84,1.84,0,0,1,.52-.05h6.74Zm2.86-.39c-.07,0-.17,0-.22,0s-.28.18-.29.28c0,.38,0,.77,0,1.18h7.69a.84.84,0,0,0,0-.1v-.87c0-.46-.06-.5-.51-.5Zm10.42,22.8V26.8a1.34,1.34,0,1,0-2.66,0V41.14a1.34,1.34,0,1,0,2.66,0Zm-5.73,0V26.8a1.34,1.34,0,1,0-2.66,0V41.14a1.34,1.34,0,1,0,2.66,0Zm-5.73,0V26.8a1.34,1.34,0,1,0-2.66,0V41.14a1.34,1.34,0,1,0,2.66,0Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/delete.svg